export const transformTimeTrackingValueToSubmitFormat = (value: string) => ({
	originalEstimate: value,
});

export const mutateTimeTrackingField = (estimate: string) => ({
	timeTrackingField: {
		originalEstimate: estimate,
	},
});
